import { createRootRoute, Outlet } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: () => (
    <div className="🏷️-root-route relative size-full">
      <Outlet />
      {/* <TanStackRouterDevtools /> */}
    </div>
  ),
});
